<template>

  <div class="container">
        <div class="card text-dark text-left">
            <div class="card-header font-weight-bold">
                <h3>Upload Image or File...</h3>
                <a>
                  <router-link to="/">
                    <img class="image col-xs-3" id="exit" src="@/assets/exit.png" height="35" width="35" alt="" />
                  </router-link> 
                </a> 
            </div>
            <div class="card-body">
                <div>
                  <input type="file" style='width: 80%' multiple accept="image/jpeg" @change="detectFiles($event.target.files)">
                  <p>&nbsp
                    <div class="progress-bar" :style="{ width: progressUpload + '%'}">{{ progressUpload }}%</div>
                  </p>
                </div>
            </div>
        </div>
  </div>

</template>

<script>
import { storage } from '../main';

export default {
  data () {
    return {
      progressUpload: 0,
      file: File,
      uploadTask: '',
    }
  },
  methods: {
    detectFiles (fileList) {
      //alert('file: ' + fileList[0].name )
      Array.from(Array(fileList.length).keys()).map( x => {
        this.upload(fileList[x])
      })
    },
    upload (file) {
      //alert('File : ' + file.name)
      this.uploadTask = storage.ref('images/' + file.name).put(file);
    }
  },
  watch: {
    uploadTask: function() {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      }, 
      null, 
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.$emit('url', downloadURL)
        })
      })
    }
  }
}
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/upload.vue